import { render, staticRenderFns } from "./text-validated.vue?vue&type=template&id=3b2eb6be&"
import script from "./text-validated.vue?vue&type=script&lang=js&"
export * from "./text-validated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports